var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5082_205620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 104,
    height: 106
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 7H8V112.998H112V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5082_205620)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5082_205620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 86,
    height: 88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52H60V69H83.6C81.4 79.8 72.2 86 60 86C45.6 86 34 74.4 34 60C34 45.6 45.6 34 60 34C66.2 34 71.8 36.2 76.2 39.8L89 27C81.2 20.2 71.2 16 60 16C35.6 16 16 35.6 16 60C16 84.4 35.6 104 60 104C82 104 102 88 102 60C102 57.4 101.6 54.6 101 52Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5082_205620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 86V34L46 60L12 86Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5082_205620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 86,
    height: 88
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52H60V69H83.6C81.4 79.8 72.2 86 60 86C45.6 86 34 74.4 34 60C34 45.6 45.6 34 60 34C66.2 34 71.8 36.2 76.2 39.8L89 27C81.2 20.2 71.2 16 60 16C35.6 16 16 35.6 16 60C16 84.4 35.6 104 60 104C82 104 102 88 102 60C102 57.4 101.6 54.6 101 52Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5082_205620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 34L46 60L60 47.8L108 40V12H12V34Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5082_205620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 86,
    height: 88
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52H60V69H83.6C81.4 79.8 72.2 86 60 86C45.6 86 34 74.4 34 60C34 45.6 45.6 34 60 34C66.2 34 71.8 36.2 76.2 39.8L89 27C81.2 20.2 71.2 16 60 16C35.6 16 16 35.6 16 60C16 84.4 35.6 104 60 104C82 104 102 88 102 60C102 57.4 101.6 54.6 101 52Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5082_205620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 86L72 40L87.8 42L108 12V108H12V86Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5082_205620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 86,
    height: 88
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52H60V69H83.6C81.4 79.8 72.2 86 60 86C45.6 86 34 74.4 34 60C34 45.6 45.6 34 60 34C66.2 34 71.8 36.2 76.2 39.8L89 27C81.2 20.2 71.2 16 60 16C35.6 16 16 35.6 16 60C16 84.4 35.6 104 60 104C82 104 102 88 102 60C102 57.4 101.6 54.6 101 52Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5082_205620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108 108L46 60L38 54L108 34V108Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ac538cb532f372f0ceb09a6adc0b18ca.svg";
export { ForwardRef as ReactComponent };